export default ({...props}) => {
  const {primaryButton, size, themeGrey} = props.theme

  return `
  &> .MuiCheckbox-root{
      margin-bottom:${size(0.75)}px;
      color:${primaryButton.foreground};
      &.Mui-checked{
        color:${primaryButton.background};
       }
      &.Mui-disabled{
         color:${themeGrey.input_active};
         &.Mui-checked{
          color:${themeGrey.disabled_grey};
         }
        }
    }
     & .MuiFormControlLabel-label{
         color:${primaryButton.foreground};
      } 
`
}
